import { QuestionStatus, QuestionGroupStatus } from '@exam-management/graphql';

export const EDITABLE_QUESTION_DETAILS_STATUSES = [
  QuestionStatus.Draft,
  QuestionStatus.PreDraft,
  QuestionStatus.Unpublished,
];

export const EDITABLE_ITEM_SET_QUESTION_DETAILS_STATUSES = [
  QuestionGroupStatus.Draft,
  QuestionGroupStatus.PreDraft,
  QuestionGroupStatus.Unpublished,
];

export const PREVIEWABLE_QUESTION_STATUSES = [
  QuestionStatus.InDevelopment,
  QuestionStatus.InReview,
  QuestionStatus.Draft,
  QuestionStatus.PreDraft,
  QuestionStatus.Unpublished,
  QuestionStatus.Published,
];

export const PREVIEWABLE_ITEM_SET_STATUSES = [
  QuestionGroupStatus.Draft,
  QuestionGroupStatus.PreDraft,
  QuestionGroupStatus.Published,
  QuestionGroupStatus.Unpublished,
];

export const EDITABLE_QUESTION_LOCATION_STATUSES = [QuestionStatus.Draft, QuestionStatus.PreDraft];

export const EDITABLE_ITEM_QUESTION_P_STAT_STATUSES = [
  QuestionStatus.Draft,
  QuestionStatus.Unpublished,
  QuestionStatus.Disabled,
];

export const EDITABLE_ITEM_QUESTION_B_INDEX_STATUSES = [
  QuestionStatus.Draft,
  QuestionStatus.Unpublished,
  QuestionStatus.Disabled,
];
